import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import {
  cleanupPaymentWidgetArtifacts,
  reloadCurrentPage,
} from '../../utils/paymentWidgetUtils';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    cleanupPaymentWidgetArtifacts();
  }

  handleReload = () => {
    cleanupPaymentWidgetArtifacts();
    reloadCurrentPage();
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="text-center p-4">
          <FontAwesomeIcon icon={faExclamationTriangle} size="2x" className="text-danger mb-3" />
          <h5 className="mb-2">Algo salió mal</h5>
          <p className="text-muted mb-4">
            {this.props.message || 'No pudimos mostrar la pantalla de pago. Recargá la página e intentá de nuevo.'}
          </p>
          <button type="button" className="btn btn-primary" onClick={this.handleReload}>
            Recargar página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
